import { render, staticRenderFns } from "./OrderOverview.vue?vue&type=template&id=8e6760cc&scoped=true"
import script from "./OrderOverview.vue?vue&type=script&lang=js"
export * from "./OrderOverview.vue?vue&type=script&lang=js"
import style0 from "./OrderOverview.vue?vue&type=style&index=0&id=8e6760cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6760cc",
  null
  
)

export default component.exports